export default __webpack_public_path__ + "static/media/tlp.3ff15bf1.jpg";